<!-- Cyber Footer -->
<footer class="cyber-footer" role="contentinfo" aria-label="Site footer">
  <div class="footer-container">
    <!-- Brand Section -->
    <div class="footer-brand">
      <p class="copyright-text">&copy; {{ currentDate | date: "yyyy" }}</p>
      <a
        href="https://scanninja.ai"
        target="_blank"
        rel="noopener noreferrer"
        class="brand-link"
        aria-label="Visit Scan Ninja Inc website"
      >
        Scan Ninja Inc
      </a>
    </div>

    <!-- Footer Meta Information -->
    <div class="footer-meta">
      <!-- Version Display -->
      @if (version) {
        <div
          class="footer-version"
          [attr.aria-label]="'Application version ' + version"
          title="Application Version"
        >
          v{{ version }}
        </div>
      }

      <!-- Footer Links -->
      <nav class="footer-links" aria-label="Footer navigation">
        <a
          href="https://www.scanninja.ai/policies/privacy-policy"
          target="_blank"
          rel="noopener noreferrer"
          class="footer-link"
          aria-label="Privacy Policy"
        >
          Privacy
        </a>
        <a
          href="https://www.scanninja.ai/policies/terms-of-use"
          target="_blank"
          rel="noopener noreferrer"
          class="footer-link"
          aria-label="Terms of Service"
        >
          Terms
        </a>
        <a
          href="https://www.scanninja.ai/policies/cookie-policy"
          target="_blank"
          rel="noopener noreferrer"
          class="footer-link"
          aria-label="Cookie Policy"
        >
          Cookies
        </a>
        <a
          [routerLink]="['/dashboard', 'support', 'list']"
          class="footer-link"
          aria-label="Support"
        >
          Support
        </a>
      </nav>
    </div>
  </div>
</footer>
